import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { PageHeader, Spinner, EmptyState, Card } from "@/components/bits";
import StatusBadge from "@/components/StatusBadge";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { ListChecks } from "lucide-react";

const FILTERS = [
  { k: "all", label: "Semua" },
  { k: "Active", label: "Waiting" },
  { k: "Partial", label: "Partial" },
  { k: "Complete", label: "Complete" },
  { k: "Problem", label: "Problem" },
  { k: "VOID", label: "Void" },
];

const COLS = [
  ["NOPOL", "left"], ["MOBIL", "left"], ["ASURANSI", "left"], ["SPK", "left"],
  ["PART", "center"], ["ORDER", "center"], ["RECEIVE", "center"], ["WH", "center"],
  ["INSTALL", "center"], ["STATUS", "left"],
];

export default function Jobs() {
  const navigate = useNavigate();
  const [status, setStatus] = useState("all");
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    api.get(`/jobs?status=${status}`).then((r) => setJobs(r.data)).finally(() => setLoading(false));
  }, [status]);

  return (
    <div>
      <PageHeader title="Daftar Kendaraan" subtitle="Status kelengkapan parts per Job / SPK. Klik NOPOL untuk lihat History." />
      <Tabs value={status} onValueChange={setStatus} className="mb-4">
        <TabsList>
          {FILTERS.map((f) => <TabsTrigger key={f.k} value={f.k} data-testid={`jobs-filter-${f.k}`}>{f.label}</TabsTrigger>)}
        </TabsList>
      </Tabs>
      {loading ? <Spinner /> : jobs.length === 0 ? (
        <EmptyState title="Belum ada job" subtitle="Job muncul setelah SPK dikonfirmasi." icon={ListChecks} />
      ) : (
        <Card className="overflow-hidden" data-testid="vehicle-list-table">
          <div className="overflow-x-auto">
            <table className="w-full text-xs">
              <thead className="bg-[rgba(0,180,255,0.05)] text-gray-500 uppercase">
                <tr>
                  {COLS.map(([c, a]) => <th key={c} className={`px-3 py-2 text-${a} whitespace-nowrap`}>{c}</th>)}
                </tr>
              </thead>
              <tbody>
                {jobs.map((j) => {
                  const s = j.parts_summary || {};
                  const wh = Math.max((s.received ?? 0) - (s.installed ?? 0), 0);
                  return (
                    <tr
                      key={j.id}
                      className="border-t border-[rgba(0,200,255,0.08)] hover:bg-[rgba(0,200,255,0.05)]"
                      data-testid={`vehicle-row-${j.id}`}
                    >
                      <td className="px-3 py-2">
                        <button
                          onClick={() => navigate(`/history?job=${j.id}`)}
                          className="font-mono-data font-semibold text-[var(--neon-cyan)] hover:underline"
                          data-testid={`vehicle-nopol-${j.id}`}
                        >
                          {j.nopol}
                        </button>
                      </td>
                      <td className="px-3 py-2 text-gray-300 cursor-pointer" onClick={() => navigate(`/jobs/${j.id}`)}>{`${j.vehicle_brand || ""} ${j.vehicle_type || ""}`.trim() || "—"}</td>
                      <td className="px-3 py-2 text-gray-400 cursor-pointer" onClick={() => navigate(`/jobs/${j.id}`)}>{j.insurance || "—"}</td>
                      <td className="px-3 py-2 font-mono-data text-gray-400 cursor-pointer" onClick={() => navigate(`/jobs/${j.id}`)}>{j.spk_number || j.claim_number || "—"}</td>
                      <td className="px-3 py-2 text-center tabular-nums text-gray-300 cursor-pointer" onClick={() => navigate(`/jobs/${j.id}`)}>{s.total ?? 0}</td>
                      <td className="px-3 py-2 text-center tabular-nums text-gray-300 cursor-pointer" onClick={() => navigate(`/jobs/${j.id}`)}>{s.ordered ?? 0}</td>
                      <td className="px-3 py-2 text-center tabular-nums text-gray-300 cursor-pointer" onClick={() => navigate(`/jobs/${j.id}`)}>{s.received ?? 0}</td>
                      <td className="px-3 py-2 text-center tabular-nums text-gray-300 cursor-pointer" onClick={() => navigate(`/jobs/${j.id}`)}>{wh}</td>
                      <td className="px-3 py-2 text-center tabular-nums text-gray-300 cursor-pointer" onClick={() => navigate(`/jobs/${j.id}`)}>{s.installed ?? 0}</td>
                      <td className="px-3 py-2 cursor-pointer" onClick={() => navigate(`/jobs/${j.id}`)}><StatusBadge status={j.status === "VOID" ? "PROBLEM" : j.status} /></td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </Card>
      )}
    </div>
  );
}
